import { homeInventoryControl } from "./home-inventory-control";
import { cardInventoryControl } from "./card-inventory-control";
import { stepperInventoryControl } from "./stepper-inventory-control";
import { stepsInventoryControl } from "./steps-inventory-control";
import { wrapperInventoryControl } from "./wrapper-inventory-control";
import { updateStatusMessage } from "./update-status-message";

export const inventoryControl = {
	title: "Inventario",
	emptyState: {
		title: "Aún no tiene inventarios",
		infoEmpty: "Haga clic en agregar crear inventario para comenzar",
		addNewInventory: "Nuevo inventario",
	},
	homeInventoryControl,
	cardInventoryControl,
	stepperInventoryControl,
	stepsInventoryControl,
	wrapperInventoryControl,
	updateStatusMessage,
};
